import { teamEmailAddressSchema } from "@redotech/redo-marketing-core-common/email/domain-verification";
import * as z from "zod";

export const getTeamEmailAddresses = {
  name: "getTeamEmailAddresses" as const,
  input: z.object({}),
  output: z.object({
    addresses: z.array(teamEmailAddressSchema),
    defaultFromAddressId: z.string().nullish(),
    defaultReplyToAddressId: z.string().nullish(),
  }),
};
